// extracted by mini-css-extract-plugin
module.exports = {"ComparativoFontes":"ComparativoFontes_ComparativoFontes__3Tyib"};